import { rage, useObservable } from '~/rage';
import { ButtonActions } from '../../components/ButtonActions';
import { StyledText } from '../../components/ButtonActions/ButtonActions.styled';
import {
	StyledContainer,
	StyledRubberContainer,
	StyledVerticalContainer,
} from '../../components/Container';
import { Selector } from '../../components/Selector';

const TuningTester: React.FC = () => {
	const vehicleMods = useObservable(rage.tuningTester.getVehicleMods());

	const handleModChange = (typeIndex: number, modIndex: number) =>
		rage.tuningTester.applyVehicleMod(typeIndex, modIndex);
	const handleExit = () => rage.tuningTester.exitMenu();

	return (
		<StyledContainer>
			<StyledVerticalContainer>
				<StyledText>{'Компоненты'}</StyledText>
				<StyledRubberContainer>
					{vehicleMods.map((e, index) => (
						<Selector
							key={`mod#${index}`}
							title={e.title}
							index={e.modIndex}
							minIndex={-1}
							maxIndex={Math.max(e.maxCount - 1, 0)}
							modIdsByIndex={e.modIdsByIndex}
							onChange={(modIndex: number) =>
								handleModChange(e.typeIndex, modIndex)
							}
						/>
					))}
				</StyledRubberContainer>
			</StyledVerticalContainer>
			<ButtonActions title={'Действия'} onExit={handleExit} />
		</StyledContainer>
	);
};

export { TuningTester };
